import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import CheckCircleFillIcon from "../../assets/images/CheckCircleFillIcon.svg";
import redCloseIcon from "../../assets/images/red-close-icon.svg"

const bgColors = {
  success: "#78A22F",
  error: "#C43131",
  warning: "#EDEDED"
}

const tostIcons = {
  success: CheckCircleFillIcon,
  error: redCloseIcon,
  warning: redCloseIcon
}

type TosterVariant = "success" | "error"  | "warning";
interface ToasterProps {
  type: TosterVariant;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
}


const Toaster: React.FC<ToasterProps> = ({ type, show, setShow, message }) => {
  return (
    <ToastContainer
      className="p-3"
      style={{ position: "fixed", top: "20px", right: "20px", zIndex: 9999 }}
    >
      <Toast
        bg="white"
        onClose={() => setShow(false)}
        show={show}
        autohide
        style={{
          border: "none",
          boxShadow: "2px 2px 4px 0px rgba(0, 0, 0, 0.15)",
          opacity: show ? 1 : 0,
          transition: "opacity 0.5s ease",
        }}
      >
        <Toast.Header
          style={{
            backgroundColor: bgColors[type],
            padding: "3px",
          }}
          closeButton={false}
        ></Toast.Header>
        <Toast.Body className="d-flex align-items-center">
          <img
            src={tostIcons[type]}
            alt="Success Icon"
            style={{ width: "20px", height: "20px", marginRight: "10px" }}
          />
          <p
            style={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#353535",
              marginBottom: "0",
              textAlign:"left"
            }}
          >
            {message}
          </p>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Toaster;
